/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateSavedAnalyticsViewRequest {
    name: string;
    screen: CreateSavedAnalyticsViewRequest.ScreenEnum;
    coverageAnalysisTab?: string;
    filtersJson: string;
}
export namespace CreateSavedAnalyticsViewRequest {
    export type ScreenEnum = 'OVERVIEW' | 'COVERAGE_DASHBOARD' | 'COVERAGE_ANALYSIS' | 'BRANDS' | 'TOPICS' | 'SENTIMENT' | 'MEDIA';
    export const ScreenEnum = {
        OVERVIEW: 'OVERVIEW' as ScreenEnum,
        COVERAGEDASHBOARD: 'COVERAGE_DASHBOARD' as ScreenEnum,
        COVERAGEANALYSIS: 'COVERAGE_ANALYSIS' as ScreenEnum,
        BRANDS: 'BRANDS' as ScreenEnum,
        TOPICS: 'TOPICS' as ScreenEnum,
        SENTIMENT: 'SENTIMENT' as ScreenEnum,
        MEDIA: 'MEDIA' as ScreenEnum
    };
}
